import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http'

import { BaseService } from '@aifs-shared/common/base-service';
import { BaseResponse } from '@aifs-shared/common/base-response';

import { Observable, Subject } from 'rxjs';

import { environment } from '@environments/environment';

// Service injectors
import { UserService } from '@aifs-shared/user/user.service';
import { AuthenticationService } from '@aifs-shared/auth/authentication.service';

// Service-specific classes
import { ToDoItem } from './todo-item';
import { ResponseData } from '@aifs-shared/common/response-data';

@Injectable()
export class ToDoService extends BaseService {
    /**
     * @description Constructor
     */
    constructor(
        router: Router,
        private http: HttpClient,
        private authService: AuthenticationService,
        private userService: UserService) {
        super();
    }

    public getToDoForApplication(applicantId: number, applicationId: number ): Observable<ToDoItem[]> {
        let subject = new Subject<ToDoItem[]>();

        this.http
            .get<BaseResponse>(environment.ServiceUrl_ApplicationToDo(applicantId, applicationId))
            .subscribe({
                next: (data) => {
                    // console.log(`Got data: ${JSON.stringify(data)}`);
                    const response = this.getResultData<ToDoItems>(data);
                    // console.log(`Got response: ${JSON.stringify(response)}`);
                    subject.next(response.toDo);
                },
                error: (error) => {
                    subject.error(error);
                }});

        return subject;
    }

}

export class ToDoItemResponse implements ResponseData {
    result?: ToDoItems;
}

export class ToDoItems {
    toDo: ToDoItem[] = [];
}